module.exports = __webpack_public_path__ + "img/usability-insights-desktop.139c6e19.svg";